/* Zen Complex — comportamiento de las secciones zc-* */
(() => {
  // Horizon: en escritorio (≥990px) el scroll ocurre en .page-wrapper, no en la ventana
  const squeeze = window.matchMedia("(min-width: 990px)");

  // Sliders con flechas (Más vendidos, Vídeos)
  const initSlider = (root) => {
    if (root.dataset.zcReady) return;
    root.dataset.zcReady = 'true';
    const track = root.querySelector('[data-zc-track]');
    const prev = root.querySelectorAll('[data-zc-prev]');
    const next = root.querySelectorAll('[data-zc-next]');
    if (!track) return;

    const step = () => {
      const item = track.firstElementChild;
      if (!item) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.forEach((b) => (b.disabled = track.scrollLeft <= 2));
      next.forEach((b) => (b.disabled = track.scrollLeft >= max));
      root.toggleAttribute('data-zc-static', max <= 0);
    };
    prev.forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
    next.forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
    track.addEventListener('scroll', update, { passive: true });
    // Medir un deslizador (¿sobresale la pista?) obliga al navegador a maquetar su sección, y las de abajo no
    // se maquetan hasta que se acercan a la pantalla (content-visibility): medirlas todas al arrancar eran
    // ~100 ms de procesador en un móvil lento. Los de las dos primeras secciones pueden estar en la primera
    // pantalla y se miden ya; el resto, al acercarse, y después solo mientras se ven (también al redimensionar).
    const section = root.closest('.shopify-section');
    const first = !section || !section.parentElement || Array.prototype.indexOf.call(section.parentElement.children, section) < 2;
    let visible = first || !('IntersectionObserver' in window);
    window.addEventListener('resize', () => { if (visible) update(); });
    if (visible) return update();
    new IntersectionObserver(
      ([entry]) => {
        visible = entry.isIntersecting;
        if (visible) update();
      },
      { root: squeeze.matches ? document.querySelector('.page-wrapper') : null, rootMargin: '300px 0px' }
    ).observe(root);
  };

  // Packs de oferta: fijan la cantidad (1, 2 o 4 botes) del formulario de Horizon
  // y actualizan el bloque de precio. El descuento lo aplica Shopify (descuentos automáticos).
  const applyBundle = (input) => {
    const bundles = input.closest('[data-zc-bundles]');
    if (!bundles) return;
    bundles.querySelectorAll('.zc-bundle').forEach((el) => el.classList.toggle('is-selected', el.contains(input)));
    const scope = input.closest('.product-information, product-component, .shopify-section') || document;
    const units = input.dataset.units || '1';
    scope.querySelectorAll('form[data-type="add-to-cart-form"] input[name="quantity"], input[name="quantity"]:not([data-cart-line])').forEach((q) => {
      q.value = units;
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const box = scope.querySelector('[data-zc-price]');
    if (box) {
      const pct = parseInt(input.dataset.pct || '0', 10);
      box.querySelector('[data-zc-price-now]').textContent = input.dataset.price;
      box.querySelector('[data-zc-price-was]').textContent = input.dataset.compare;
      box.querySelector('[data-zc-price-pct]').textContent = pct;
      const saving = box.querySelector('[data-zc-price-saving]');
      if (saving) saving.textContent = input.dataset.saving;
      ['[data-zc-price-was]', '[data-zc-price-pill]', '[data-zc-price-save]'].forEach((sel) => {
        const el = box.querySelector(sel);
        if (el) el.hidden = pct <= 0;
      });
    }
    // La barra fija de compra (zc-cod-sticky.js) copia el precio del pack
    document.dispatchEvent(new CustomEvent('zc:bundle-updated'));
  };
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.classList.contains('zc-bundle__input')) applyBundle(input);
  });
  const initBundles = (scope = document) =>
    scope.querySelectorAll('[data-zc-bundles] .zc-bundle__input:checked').forEach(applyBundle);
  // Horizon puede devolver la cantidad a 1 después de añadir: se vuelve a aplicar el pack
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('.add-to-cart-button')) {
      [1200, 2500].forEach((ms) => setTimeout(() => initBundles(), ms));
    }
  });

  // Vídeos: reproducir al pulsar
  const initVideos = (root) => {
    root.querySelectorAll('.zc-video').forEach((card) => {
      if (card.dataset.zcReady) return;
      card.dataset.zcReady = 'true';
      const video = card.querySelector('video');
      const btn = card.querySelector('.zc-video__play');
      if (!video || !btn) return;
      const play = () => {
        root.querySelectorAll('.zc-video.is-playing video').forEach((v) => {
          if (v !== video) {
            v.pause();
            v.closest('.zc-video').classList.remove('is-playing');
          }
        });
        video.muted = false;
        video.controls = true;
        video.play();
        card.classList.add('is-playing');
      };
      btn.addEventListener('click', play);
      video.addEventListener('pause', () => {
        if (video.seeking) return;
        card.classList.remove('is-playing');
      });
    });
  };

  // Aparición suave al hacer scroll
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const io =
    'IntersectionObserver' in window && !designMode
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.add('is-in');
                io.unobserve(e.target);
              }
            });
          },
          { root: squeeze.matches ? document.querySelector('.page-wrapper') : null, rootMargin: '0px 0px -8% 0px' }
        )
      : null;

  const init = (scope = document) => {
    scope.querySelectorAll('[data-zc-slider]').forEach(initSlider);
    scope.querySelectorAll('.zc-videos').forEach(initVideos);
    scope.querySelectorAll('.zc-reveal:not(.is-in)').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));
  };

  // Botón flotante de WhatsApp: la X cierra la etiqueta. No se guarda: reaparece en cada carga.
  const initWhatsApp = () => {
    document.querySelectorAll('[data-zc-wa]').forEach((root) => {
      const close = root.querySelector('[data-zc-wa-close]');
      if (!close || close.dataset.zcReady) return;
      close.dataset.zcReady = 'true';
      close.addEventListener('click', (event) => {
        event.preventDefault();
        root.classList.add('is-label-closed');
      });
    });
  };

  // Galería de producto: la foto principal va sola. Las demás llegan como «lazy» (snippets/product-media.liquid)
  // y se piden por turnos para que no se repartan la conexión con ella:
  // - la segunda, que en móvil asoma por la derecha, en cuanto la principal ha llegado;
  // - de la tercera en adelante (no se ven hasta deslizar), cuando la página ha terminado de cargar y el
  //   navegador está libre, o al primer gesto sobre la galería, lo que ocurra antes.
  const initGallery = () => {
    const rest = [...document.querySelectorAll('img[data_zc_after_main]')];
    if (!rest.length) return;
    const fetchNow = (imgs) => imgs.forEach((img) => { img.loading = 'eager'; });
    const soon = rest.filter((img) => img.getAttribute('data_zc_after_main') !== 'later');
    const later = rest.filter((img) => img.getAttribute('data_zc_after_main') === 'later');
    if (later.length) {
      let done = false;
      const fetchLater = () => { if (!done) { done = true; fetchNow(later); } };
      const gallery = later[0].closest('media-gallery, .media-gallery--carousel');
      if (gallery) {
        // `scroll` no burbujea: se escucha en captura (deslizar el carrusel con el dedo)
        ['pointerover', 'pointerdown', 'touchstart', 'keydown', 'focusin', 'scroll'].forEach((type) =>
          gallery.addEventListener(type, fetchLater, { once: true, passive: true, capture: true })
        );
      }
      const whenIdle = () => {
        const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
        setTimeout(() => idle(fetchLater, { timeout: 3000 }), 1500);
      };
      if (document.readyState === 'complete') whenIdle();
      else window.addEventListener('load', whenIdle, { once: true });
    }
    const fetchSoon = () => fetchNow(soon);
    const main = document.querySelector('img.product-media__image[fetchpriority="high"]');
    if (!main || main.complete) return fetchSoon();
    main.addEventListener('load', fetchSoon, { once: true });
    main.addEventListener('error', fetchSoon, { once: true });
    // Por si la principal no llega a pedirse (pestaña en segundo plano, etc.)
    window.addEventListener('load', fetchSoon, { once: true });
  };

  // Vídeos (banner de marca, vídeos y opiniones de clientes): el HTML no lleva portada ni precarga
  // (`data-zc-poster`, preload="none"). La portada se pide cuando el vídeo se acerca a la pantalla, a un
  // tamaño acorde con su caja, y el archivo de vídeo solo al pulsar reproducir.
  const initPosters = (scope = document) => {
    const videos = [...scope.querySelectorAll('video[data-zc-poster]')].filter((video) => !video.dataset.zcPosterReady);
    if (!videos.length) return;
    const show = (video) => {
      const small = video.dataset.zcPosterSmall;
      const need = video.getBoundingClientRect().width * (window.devicePixelRatio || 1);
      // Con loading="lazy" en el <video>, Chrome no pide una portada puesta después: fuera antes de ponerla
      video.removeAttribute('loading');
      video.poster = small && need > 0 && need <= Number(video.dataset.zcPosterSmallWidth || 0) ? small : video.dataset.zcPoster;
    };
    videos.forEach((video) => { video.dataset.zcPosterReady = 'true'; });
    if (!('IntersectionObserver' in window) || designMode) return videos.forEach(show);
    const posterIo = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        posterIo.unobserve(entry.target);
        show(entry.target);
      }),
      { root: squeeze.matches ? document.querySelector('.page-wrapper') : null, rootMargin: '600px 0px' }
    );
    videos.forEach((video) => posterIo.observe(video));
  };

  // Visto en redes: la cinta se detiene fuera de pantalla y mientras se mantiene el dedo encima
  const initSocial = (scope = document) => {
    scope.querySelectorAll('[data-zc-social]').forEach((root) => {
      if (root.dataset.zcReady) return;
      root.dataset.zcReady = 'true';
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => root.classList.toggle('is-offscreen', !entry.isIntersecting), { rootMargin: '100px 0px' }).observe(root);
      }
      const hold = (on) => (event) => { if (event.pointerType !== 'mouse') root.classList.toggle('is-held', on); };
      root.addEventListener('pointerdown', hold(true), { passive: true });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach((type) => root.addEventListener(type, hold(false), { passive: true }));
    });
  };

  // En cifras: los números cuentan desde 0 la primera vez que se ven. El HTML ya trae el valor final
  // (se reserva su ancho para que nada se mueva); con «reducir movimiento» no se anima.
  const initCount = (scope = document) => {
    const els = [...scope.querySelectorAll('[data-zc-count]')].filter((el) => !el.dataset.zcReady);
    if (!els.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        io.unobserve(el);
        const final = el.textContent.trim();
        const target = /^\d{1,6}$/.test(final) ? parseInt(final, 10) : NaN;
        if (!target) return;
        el.style.minWidth = el.getBoundingClientRect().width + 'px';
        const t0 = performance.now();
        const step = (now) => {
          const p = Math.min(1, (now - t0) / 1200);
          el.textContent = p < 1 ? String(Math.round(target * (1 - Math.pow(1 - p, 3)))) : final;
          if (p < 1) requestAnimationFrame(step);
        };
        el.textContent = '0';
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach((el) => { el.dataset.zcReady = 'true'; io.observe(el); });
  };

  // Prensa: efecto «fijado». Al llegar al bloque, este se queda quieto (position: sticky) y bajar por la
  // página desliza las tarjetas en horizontal hasta la última; después la página sigue. Lo mueve el
  // scroll normal (nada de capturar la rueda ni el dedo) y solo cambia `transform`.
  // - El alto disponible se mide con la ventana PEQUEÑA del móvil (100svh: barra del navegador visible),
  //   así que la barra que aparece y desaparece al desplazar no recoloca ni suelta el bloque.
  // - Si el bloque no cabe entre la cabecera y la barra de compra se compacta por niveles (.is-tight-1…3)
  //   en vez de rendirse; solo vuelve al deslizador normal si ni así cabe, si las tarjetas ya caben
  //   todas a lo ancho o con «reducir movimiento».
  // - Recorrido: ~0,8 pantallas de scroll por tarjeta, con una pequeña espera al entrar y al salir, y
  //   la pista se acerca a su posición con suavizado (constante de tiempo ~100 ms).
  const initPress = (scope = document) => {
    scope.querySelectorAll('[data-zc-press-pin]').forEach((root) => {
      if (root.dataset.zcPinReady) return;
      root.dataset.zcPinReady = 'true';
      const pin = root.querySelector('.zc-press__pin');
      const inner = pin && pin.querySelector('.zc-press__inner');
      const slider = root.querySelector('.zc-press__slider');
      const track = root.querySelector('.zc-press__track');
      const bar = root.querySelector('.zc-press__progress span');
      if (!inner || !slider || !track || !track.lastElementChild) return;
      if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !('ResizeObserver' in window)) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      const PER_CARD = 0.78;  // pantallas de scroll por tarjeta
      const HOLD = 0.18;      // pantallas de espera al entrar y al salir
      const TAU = 100;        // ms del suavizado
      const TIGHT = ['is-tight-1', 'is-tight-2', 'is-tight-3'];
      let active = false, near = false, dist = 0, extra = 0, hold = 0, top = 0, avail = 0, seenW = 0;
      let current = 0, frame = 0, last = 0;

      const draw = () => {
        track.style.transform = 'translate3d(' + -Math.round(current * 10) / 10 + 'px,0,0)';
        if (bar) bar.style.transform = 'scaleX(' + (0.12 + 0.88 * (dist ? current / dist : 0)) + ')';
      };
      const clear = () => {
        active = false;
        if (frame) cancelAnimationFrame(frame);
        frame = 0; current = 0;
        root.classList.remove('is-pin', ...TIGHT);
        track.style.transform = '';
        if (bar) bar.style.transform = '';
      };
      // Posición a la que debe ir la pista según lo que se ha desplazado la página dentro del bloque
      const target = () => {
        const scrolled = top - pin.getBoundingClientRect().top;
        return dist * Math.min(1, Math.max(0, (scrolled - hold) / (extra - 2 * hold)));
      };
      const tick = (now) => {
        frame = 0;
        if (!active) return;
        const goal = target();
        const dt = Math.min(300, now - last); last = now;
        current += (goal - current) * (1 - Math.exp(-dt / TAU));
        if (Math.abs(goal - current) < 0.4) current = goal;
        draw();
        if (current !== goal && near) frame = requestAnimationFrame(tick);
      };
      const kick = () => { if (active && near && !frame) { last = performance.now(); frame = requestAnimationFrame(tick); } };
      // Cuánto sobresale la pista por la derecha (0 si todas las tarjetas caben)
      const overflow = () => {
        const end = track.lastElementChild.getBoundingClientRect().right - track.getBoundingClientRect().left + track.scrollLeft;
        return Math.round(end + (parseFloat(getComputedStyle(track).paddingRight) || 0) - slider.clientWidth);
      };
      // Alto de la ventana pequeña (con la barra del navegador visible); no cambia al desplazar
      const smallViewport = () => {
        const probe = document.createElement('div');
        probe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:100svh;visibility:hidden;pointer-events:none';
        document.body.appendChild(probe);
        const h = probe.offsetHeight;
        probe.remove();
        return h > 0 ? Math.min(h, window.innerHeight) : window.innerHeight;
      };
      const bars = () => {
        const header = document.querySelector('#header-component[sticky="always"]');
        const buy = document.querySelector('.zc-cod-sticky');
        const buyFixed = buy && getComputedStyle(buy).position === 'fixed';
        // La barra de compra cuenta aunque ahora esté oculta: aparece al desplazar
        return [header ? Math.round(header.getBoundingClientRect().height) : 0, buyFixed ? (buy.offsetHeight || parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--zc-cod-sticky-h')) || 69) : 0];
      };
      const layout = () => {
        seenW = window.innerWidth;
        clear();
        if (reduce.matches || overflow() < 24) return;
        const vh = smallViewport();
        const [headerH, buyH] = bars();
        avail = vh - headerH - buyH;
        root.classList.add('is-pin');
        // Se compacta solo lo necesario para que quepa
        for (let n = 0; n < TIGHT.length && inner.offsetHeight > avail; n++) root.classList.add(TIGHT[n]);
        const h = inner.offsetHeight;
        if (h > avail) return clear();
        dist = overflow();
        if (dist < 24) return clear();
        const card = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        const steps = Math.max(1, dist / card);
        hold = Math.round(vh * HOLD);
        extra = Math.round(Math.min(steps * PER_CARD * vh, vh * 4) + 2 * hold);
        top = headerH + Math.round((avail - h) / 2);
        root.style.setProperty('--zc-pin-dist', dist + 'px');
        root.style.setProperty('--zc-pin-extra', extra + 'px');
        root.style.setProperty('--zc-pin-top', top + 'px');
        active = true;
        current = target();
        draw();
      };
      new IntersectionObserver(([entry]) => {
        near = entry.isIntersecting;
        if (!near) return;
        if (window.innerWidth !== seenW) layout(); else kick();
      }, { rootMargin: '100% 0px' }).observe(root);
      // Si cambia el alto del bloque fijado (fuentes, textos) y deja de caber, se rehace
      new ResizeObserver(() => { if (near && active && inner.offsetHeight > avail) layout(); }).observe(inner);
      // Solo los cambios de ANCHO (giro, redimensión) rehacen el cálculo; los de alto son la barra del navegador
      let resizeTimer = 0;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { if (window.innerWidth === seenW) return; if (near) layout(); else seenW = 0; }, 150);
      }, { passive: true });
      reduce.addEventListener('change', () => { seenW = 0; if (near) layout(); });
      document.addEventListener('scroll', kick, { passive: true, capture: true });
    });
  };

  const boot = () => {
    init();
    initBundles();
    initWhatsApp();
    initGallery();
    initPosters();
    initSocial();
    initCount();
    initPress();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Editor del tema
  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
    initBundles(e.target);
    initPosters(e.target);
    initSocial(e.target);
    initCount(e.target);
    e.target.querySelectorAll('.zc-reveal').forEach((el) => el.classList.add('is-in'));
  });
})();
